<template>
    <div>
        <Menu
            :restaurant="restaurant"
            :token="token"
            :customerprop="customerprop" :app_locale="app_locale"
            :has_free_delivery="has_free_delivery"
            :should_upsell="should_upsell"
            :upsell_fee="upsell_fee"
            ></Menu>
        
    </div>
</template>

<script>
import Menu from "../../components/App/Menu";

export default {
  name: "Index",
    props: ['restaurant', 'token', 'customerprop', 'app_locale', 'has_free_delivery', 'should_upsell', 'upsell_fee'],
    components: {Menu},
    data() {
        return {
            
        }
    },
    methods: {
      
    }
    
}
</script>

<style scoped>

</style>
